import { api } from "./api";
import { ITask, CreateTaskRequest, UpdateTaskRequest, TaskFilters, TaskStats } from "../types/task.type";

export const taskApi = {
  // Получение статистики задач
  getStats: (): Promise<TaskStats> => {
    return api.get("/task/stats").then((response: any) => {
      console.log("Stats API Response:", response);
      const data = response.data || response;
      console.log("Stats processed data:", data);
      return data;
    });
  },

  // Получение всех задач с фильтрацией
  getTasks: (filters?: TaskFilters): Promise<{ tasks: ITask[] }> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
          } else {
            params.append(key, value.toString());
          }
        }
      });
    }
    return api.get(`/task?${params.toString()}`).then((response: any) => {
      console.log("API Response:", response);
      console.log("API Response data:", response.data);
      
      // Получаем данные из response.data
      const data = response.data || response;
      
      // Преобразуем объект в массив, если нужно
      if (data.tasks && typeof data.tasks === 'object' && !Array.isArray(data.tasks)) {
        data.tasks = Object.values(data.tasks);
      }
      
      console.log("Processed data:", data);
      return data;
    });
  },

  // Получение одной задачи
  getTask: (taskId: string): Promise<{ task: ITask }> => {
    return api.get(`/task/${taskId}`);
  },

  // Создание новой задачи
  createTask: (data: CreateTaskRequest): Promise<{ message: string; task: ITask }> => {
    return api.post("/task", data);
  },

  // Обновление задачи
  updateTask: (taskId: string, data: UpdateTaskRequest): Promise<{ message: string; task: ITask }> => {
    return api.put(`/task/${taskId}`, data);
  },

  // Удаление задачи
  deleteTask: (taskId: string): Promise<{ message: string }> => {
    return api.delete(`/task/${taskId}`);
  },

  // Добавление комментария к задаче
  addComment: (taskId: string, text: string): Promise<{ message: string; task: ITask }> => {
    return api.post(`/task/${taskId}/comments`, { text });
  }
}; 